export const shortenString = (input: string, length = 35, lengthEnd = 8): string => {
  return input.length > length ? `${input.substring(0, length - lengthEnd - 1)}...${input.slice(-lengthEnd)}` : input
}
